import React, { useState } from "react";
import { HiOutlineEye, HiOutlinePhone, HiOutlineMapPin, HiOutlineCheckCircle, HiOutlineXMark } from "react-icons/hi2";

const customers = [
  { id: 1, name: "Jarrell Hilpert", phone: "(966) 965-9743", address: "11089 Mustafa Hills, Lindenhurst, NY 11338", createdAt: "January 11, 2025 / 10:32 pm", status: "Active", orders: [{ orderId: 271, status: "Cancelled", amount: "USD 57", store: "Regan Manor" }, { orderId: 512, status: "Cancelled", amount: "USD 11", store: "Daron Ridge" }] },
  { id: 2, name: "Carmela Larkin", phone: "(470) 109-7972", address: "11500 Dietrich Stravenue, Brooklyn, NY 11655", createdAt: "January 19, 2025 / 02:38 pm", status: "Idle", orders: [] },
];

const CustomersTable = () => {
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleOpenDrawer = (customer) => { setSelectedCustomer(customer); setDrawerOpen(true); };
  const handleCloseDrawer = () => setDrawerOpen(false);

  return (
    <div className="page-container">
      <h1 className="page-title mb-6">Customers</h1>

      <div className="card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-slate-200 bg-slate-50">
                <th className="table-header">ID</th>
                <th className="table-header">Name</th>
                <th className="table-header">Phone</th>
                <th className="table-header">Address</th>
                <th className="table-header">Created At</th>
                <th className="table-header">Status</th>
                <th className="table-header">Actions</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((c) => (
                <tr key={c.id} className="border-b border-slate-100 hover:bg-slate-50 transition-colors">
                  <td className="table-cell font-medium">#{c.id}</td>
                  <td className="table-cell font-medium text-slate-900">{c.name}</td>
                  <td className="table-cell">{c.phone}</td>
                  <td className="table-cell text-slate-500 max-w-xs truncate">{c.address}</td>
                  <td className="table-cell text-slate-500">{c.createdAt}</td>
                  <td className="table-cell"><span className={c.status === "Active" ? "badge-green" : "badge-gray"}>{c.status}</span></td>
                  <td className="table-cell">
                    <button onClick={() => handleOpenDrawer(c)} className="btn-icon"><HiOutlineEye className="w-5 h-5" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Drawer */}
      {drawerOpen && (
        <>
          <div className="overlay" onClick={handleCloseDrawer} />
          <aside className="fixed top-0 right-0 z-50 h-full w-full max-w-sm bg-white shadow-modal overflow-y-auto">
            {selectedCustomer && (
              <div className="p-6">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-xl font-bold text-slate-900">{selectedCustomer.name}</h2>
                  <button onClick={handleCloseDrawer} className="btn-icon"><HiOutlineXMark className="w-5 h-5" /></button>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center gap-2 text-sm"><HiOutlinePhone className="w-5 h-5 text-slate-400" /><span>{selectedCustomer.phone}</span></div>
                  <div className="flex items-center gap-2 text-sm"><HiOutlineMapPin className="w-5 h-5 text-slate-400" /><span>{selectedCustomer.address}</span></div>
                  <div className="flex items-center gap-2 text-sm"><HiOutlineCheckCircle className="w-5 h-5 text-emerald-500" /><span>{selectedCustomer.status}</span></div>
                </div>
                <h3 className="section-title mt-6 mb-3">Orders</h3>
                {selectedCustomer.orders.length > 0 ? (
                  <div className="space-y-2">
                    {selectedCustomer.orders.map((o) => (
                      <div key={o.orderId} className="p-3 rounded-lg bg-slate-50 text-sm">
                        <p className="font-medium text-slate-800">Order #{o.orderId} - {o.amount}</p>
                        <p className="text-slate-500">Status: {o.status} | Store: {o.store}</p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-sm text-slate-400">No orders available</p>
                )}
              </div>
            )}
          </aside>
        </>
      )}
    </div>
  );
};

export default CustomersTable;
